import { Avatar, Badge, Box, Button, IconButton, Link, Typography } from '@mui/material';
import MallIcon from '../components/MallIcon';
import ObservedLine from '../components/ObservedLine';
import { useLoaderData, useLocation, useNavigate, useParams } from 'react-router-dom';
import { MallMainLoader } from '@/router';
import { useOpenAlertDialog } from '@/store/alertDialogStore';
import { toast } from 'react-toastify';
import { MallInfo, MallNotification } from '@/services/mallUser.service';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import config from '@/config/config';

type MallBannerPropType = {
    mallInfo: MallInfo['mallInfo'];
    notificationList: MallNotification['notificationList'];
}

function MallBanner() {
    const { path = '' } = useParams()
    // const { mallInfo, notificationList } = useLoaderData() as MallMainLoader;
    // const pindedNotification = notificationList.find((notification) => notification.isPinned);

    const doCopy = (text: string) => {
        // TODO: 주문번호 복사 코드 추후 리팩토링 요함

        // 흐음 1.
        if (navigator.clipboard) {
        // (IE는 사용 못하고, 크롬은 66버전 이상일때 사용 가능합니다.)
            navigator.clipboard
            .writeText(text)
            .then(() => {
                // alert("클립보드에 복사되었습니다.");
                // toast.success('클립보드에 복사되었습니다.')
            })
            .catch(() => {
                toast.error("복사를 다시 시도해주세요.");
            });
        } else {
        // 흐름 2.
            if (!document.queryCommandSupported("copy")) {
                return toast.error("복사하기가 지원되지 않는 브라우저입니다.");
            }

        // 흐름 3.
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.style.top = '0';
            textarea.style.left = '0';
            textarea.style.position = "fixed";

        // 흐름 4.
            document.body.appendChild(textarea);
        // focus() -> 사파리 브라우저 서포팅
            textarea.focus();
        // select() -> 사용자가 입력한 내용을 영역을 설정할 때 필요
            textarea.select();
        // 흐름 5.
            document.execCommand("copy");
        // 흐름 6.
            document.body.removeChild(textarea);
            // alert("클립보드에 복사되었습니다.");
            // toast.success('클립보드에 복사되었습니다.')
        }
    };
    return (
        <>
            <MallBannerContainer>
                {/* {pindedNotification?.title && <Notification content={pindedNotification?.title || ''} />} */}

                {/* <MallProfileImage src={mallInfo?.profileImage} /> */}

                {/* <MallIntro mallName={mallInfo?.name} description={mallInfo?.description} snsInfo={mallInfo?.snsInfo} /> */}
                {/* <MallIntro mallName={'플로잉'} description={'플로잉 상점'} snsInfo={mallInfo?.snsInfo} /> */}
                <Box sx={{ p: 15 }} />
                <Box display={'flex'} margin="3%">
                    <Box flexGrow={1} />
                    <IconButton
                        sx={{ marginRight: '4%' }}
                        onClick={() => {
                            try {
                                doCopy(window?.location?.href);
                                toast.success('주소가 클립보드에 복사되었습니다.');
                            } catch (error) {
                                console.log('몰 공유하기 클립보드 복사', error);
                            }
                        }}
                    >
                        <MallIcon size="nav" iconName="share" color="white" />
                    </IconButton>
                </Box>
            </MallBannerContainer>
            <ObservedLine />
        </>
    );
}

export default MallBanner;

function MallBannerContainer({ children }) {
    // const { mallInfo: { backgroundColor } } = useLoaderData() as any
    const imgUrl = 'https://flowing-web-resources.s3.ap-northeast-2.amazonaws.com/static/lazymall_home_banner2.jpg'
    return (
        <Box
            display={'flex'}
            flexDirection={'column'}
            // bgcolor={backgroundColor}
            sx={{
                backgroundImage: `url(${imgUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
            {children}
        </Box>
    );
}

// function Notification({ content }) {
//     const navigate = useNavigate()
//     const { path = 'real-edwin' } = useParams()
//     const { notificationList } = useLoaderData() as MallMainLoader;
//     const pindedNotification = notificationList.find((notification) => notification.isPinned);
    
//     return (
//         <Box
//             width={'90%'}
//             padding="2% 0"
//             border={'solid 0 #000'}
//             margin="65px auto 0"
//             borderRadius={'10px'}
//             bgcolor={'rgba(0,0,0,0.3)'}
//             zIndex="100"
//             onClick={() => {
//                 navigate(`/mall/${path}/notice-detail/0`, {
//                     state: { data: pindedNotification },
//                 });
//             }}
//             sx={{
//                 cursor: 'pointer',
//             }}
//         >
//             <Typography noWrap={true} color={'white'} textOverflow="ellipsis" margin={'auto 3%'}>
//                 {'[공지사항] ' + content}
//             </Typography>
//         </Box>
//     );
// }

function MallProfileImage({ src = '' }) {
    const { path = 'real-edwin' } = useParams()
    return (
        <Box sx={{ display: 'flex', p: 10 }}>
            {/* <Badge
                sx={{ margin: '20% auto 0' }}
                overlap="circular"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                // badgeContent={(
                //     <a
                //         style={{
                //             border: '.1px solid black',
                //             borderRadius: '50%',
                //             backgroundColor: 'white',
                //             padding: '5px',
                //             color: 'black',
                //             textDecoration: 'none',
                //         }}
                //         href={`${config.api.flowing_spacehome_url}/${path}`}
                //         target='_blank'
                //     >
                //         <MallIcon
                //             color="black"
                //             iconName="profile-link"
                //             size="nav"
                //         />
                //     </a>
                // )}
            >
                <Avatar
                    srcSet={''}
                    sx={{
                        width: '100px',
                        height: '100px',
                        bgcolor: 'lightgray',
                    }}
                />
            </Badge> */}

        </Box>
    );
}

function MallIntro({ mallName, description, snsInfo }) {
    return (
        <>
            <Typography variant="h1" margin="3% auto 0" color={'#fff'} sx={{fontSize:'22px', fontWeight: '700'}}>
                {mallName}
            </Typography>
            <Typography noWrap={true} margin="2% auto" textOverflow="ellipsis" color={'#fff'} sx={{maxWidth:'70%'}}>
                {description}
            </Typography>
            {/* <Box className="flex" margin="2% auto">
                {!!snsInfo && snsInfo.length > 0 && snsInfo.map((item: any) => {
                    if ((item?.sns_name === 'youtube' || item?.snsName === 'youtube') && !!item.url) {
                        return (
                            <IconButton
                                sx={{ color: 'lightgray' }}
                                onClick={() => {
                                    window.open(item.url)
                                }}
                                key={item.url}
                            >
                                <YouTubeIcon fontSize='large' color='inherit' />
                            </IconButton>
                        )
                    } else if ((item?.sns_name === 'instagram' || item?.snsName === 'instagram') && !!item.url) {
                        return (
                            <IconButton
                                sx={{ color: 'lightgray' }}
                                onClick={() => {
                                    window.open(item.url)
                                }}
                                key={item.url}
                            >
                                <InstagramIcon fontSize='large' color='inherit' />
                            </IconButton>
                        )
                    }
                })}
            </Box> */}
        </>
    );
}
